export const Domain = "pdviewa2.com.au";
export const DefaultPdClientType = "azure";
export const EnvironmentName = "PreProd";
